import React from 'react';
import { createRoot } from 'react-dom/client'

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import Orders from './components/Front/Orders/Orders';
import OrderStatus from './components/Front/OrderStatus/OrderStatus';
import OrdersGrid from './components/Admin/OrdersGrid/OrdersGrid';
import SearchMap from './components/Front/SearchMap/SearchMap';
import Companies from './components/SuperAdmin/Companies/Companies';
import CompaniesScrapped from './components/SuperAdmin/CompaniesScrapped/CompaniesScrapped';
import CreateEquipment from './components/Admin/Equipments/CreateEquipment/CreateEquipment';
import CreateTrail from './components/Admin/Trails/CreateTrail/CreateTrail';
import EditTrail from './components/Admin/Trails/EditTrail/EditTrail';
import TrailEquipments from './components/Admin/Trails/TrailEquipments/TrailEquipments';
import EditEquipment from './components/Admin/Equipments/EditEquipment/EditEquipment';

dayjs.extend(customParseFormat);

let container = null;

container = document.querySelector('#app-front-orders');
if (container) {
    createRoot(container).render(
        <Orders
            trailId={+container.dataset.trailId}
            minDate={container.dataset.minDate}
        />,
    );
}

container = document.querySelector('#app-front-order-status');
if (container) {
    createRoot(container).render(
        <OrderStatus id={+container.dataset.orderId} />,
    );
}

container = document.querySelector('#app-admin-orders-grid');
if (container) {
    createRoot(container).render(
        <OrdersGrid
            trailId={+container.dataset.trailId}
            date={container.dataset.date}
        />,
    );
}

container = document.querySelector('#app-search-map');
if (container) {
    createRoot(container).render(<SearchMap />);
}

container = document.querySelector('#app-companies');
if (container) {
    createRoot(container).render(<Companies />);
}

container = document.querySelector('#app-companies-scrapped');
if (container) {
    createRoot(container).render(<CompaniesScrapped />);
}

container = document.querySelector('#app-admin-equipment-create');
if (container) {
    createRoot(container).render(
        <CreateEquipment companyId={container.dataset.companyId} />,
    );
}

container = document.querySelector('#app-admin-equipment-edit');
if (container) {
    createRoot(container).render(
        <EditEquipment
            companyId={container.dataset.companyId}
            equipmentId={container.dataset.equipmentId}
        />,
    );
}

container = document.querySelector('#app-admin-trail-create');
if (container) {
    createRoot(container).render(
        <CreateTrail companyId={container.dataset.companyId} />,
    );
}

container = document.querySelector('#app-admin-edit-create');
if (container) {
    createRoot(container).render(
        <EditTrail
            companyId={container.dataset.companyId}
            trailId={container.dataset.trailId}
        />,
    );
}

container = document.querySelector('#app-admin-trail-eqipments');
if (container) {
    createRoot(container).render(
        <TrailEquipments
            companyId={container.dataset.companyId}
            trailId={container.dataset.trailId}
        />,
    );
}